<template>
  <v-row>
    <v-col cols="12" REGISTER ALERT v-if="user && user.access && !user.verified_email">
      <v-alert type="error" :value="true" :class="`${arabic?'arFont':'enFont'}`">
        {{ i18n["please_verify_your_email"] }}
        <v-card-actions>
          <v-btn color="primary" :class="`${arabic?'arFont':'enFont'}`" @click="sendEmail()">
            {{ i18n["send_verification_email"] }}
          </v-btn>
        </v-card-actions>
      </v-alert>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios'
import countries from '../countries-ash.json'
export default {
  data() {
      return {
        dialog:false,
        phone_number:null,
        country_code:null,
        submit:null,
        loading:null,
        secret:null,
        countries:countries.map(x=>{return{...x, callingCodes:x.callingCodes[0]}}),
        session_token:null,
      }
  },
  methods:{
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x=>typeof x == 'string')
      let a = false
      v.forEach(x=>{
        if(x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if(itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    async sendEmail() {
      return new Promise(async(res, rej)=>{
        this.loading = true
        let r = await this.$store.dispatch('getResource', {resource:'/email-verification/' + this.user.id})
        this.$emit('snackbarNotification', this.i18n["a_link_is_sent_to_your_email"], 'success')
        
        this.loading = false
      })
    },
    
    isNumber(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode != 46 && charCode != 45 && charCode != 46 &&
        !(charCode >= 48 && charCode <= 57)) {
          evt.preventDefault();;
        } else {
          return true;
        }
      },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
    paymentMethods(){
      return this.$store.state.paymentMethods
    },
  },
}
</script>

<style>

</style>